import React, { useEffect } from "react";
import Input from "../../atoms/Input/Input";
import { useFormContext } from "react-hook-form";
import FileInput from "../../atoms/FileInput/FileInput";

const HomeBannerSection = () => {
  const {
    formState: { errors },
    register,
    control,
    getValues,
  } = useFormContext();

  return (
    <div className="flex-column gap-20">
      <FileInput
        label="Banner Image*"
        register={register}
        registerName="homeBannerImage"
        disabled={false}
        accept="image/png,image/jpeg,image/jpg,image/svg+xml"
        control={control}
        errorMessage={errors?.homeBannerImage?.message}
        value={getValues("homeBannerImage") ?? ""}
      />
      <Input
        type="text"
        placeholder="Title"
        label="Title*"
        register={register}
        registerName="homeBannerTitle"
        errorMessage={errors?.homeBannerTitle?.message}
      />
      <Input
        type="textarea"
        label="Description*"
        placeholder="Description"
        register={register}
        registerName="homeBannerDescription"
        errorMessage={errors?.homeBannerDescription?.message}
      />
    </div>
  );
};

export default HomeBannerSection;
